import disableSchema from './disable'
import contractStepConfig from './contractStepConfig'
import contractStepPlan from './contractStepPlan'
import contractConfig from './contractConfig'
import contractPlan from './contractPlan'
import migratePlanConfig from './migratePlanConfig'
import contractSuspend from './contractSuspend'

export default {
  disableSchema,
  contractStepConfig,
  contractStepPlan,
  contractConfig,
  contractPlan,
  migratePlanConfig,
  contractSuspend,
}
